module.exports = __webpack_public_path__ + "static/media/org_email.8a4760ad.svg";